import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { SonstigerDebitor } from '../sonstiger-debitor';

@Component({
    selector: 'kiene-sonstiger-debitor-dialog',
    templateUrl: './sonstiger-debitor-dialog.component.html',
    styleUrls: ['../../institutionen/institution-dialog/institution-dialog.component.scss'],
})
export class SonstigerDebitorDialogComponent implements OnInit {
    isEdit = false;
    bezeichnungCtrl = new UntypedFormControl('', [Validators.required]);
    kurzCtrl = new UntypedFormControl('');
    strasseCtrl = new UntypedFormControl('');
    plzCtrl = new UntypedFormControl('');
    ortCtrl = new UntypedFormControl('');
    aktivCtrl = new UntypedFormControl(true);
    kommentarCtrl = new UntypedFormControl('');
    kontoNrCtrl = new UntypedFormControl('');
    kreditorKontoNrCtrl = new UntypedFormControl('');
    debitor: any = null;
    kreditor: any = null;
    erloes: any = null;
    debitorParams = new HttpParams().set('konto_typ', '6').set('aktiv', '1');
    kreditorParams = new HttpParams().set('konto_typ', '5').set('aktiv', '1');
    erloesParams = new HttpParams().set('erloes_sonstig', '1').set('aktiv', '1');
    private id: number = null;

    constructor(
        public dialogRef: MatDialogRef<SonstigerDebitorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: { debitor: SonstigerDebitor },
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneTableService,
        private messageService: MessageService,
    ) {}

    ngOnInit(): void {
        const f = this.data?.debitor;
        if (f?.sonstiger_debitor_id) {
            this.isEdit = true;
            this.id = f.sonstiger_debitor_id;
            this.bezeichnungCtrl.setValue(f.bezeichnung);
            this.kurzCtrl.setValue(f.bezeichnung_kurz);
            this.strasseCtrl.setValue(f.strasse);
            this.plzCtrl.setValue(f.plz);
            this.ortCtrl.setValue(f.ort);
            this.aktivCtrl.setValue(f.aktiv > 0);
            this.kommentarCtrl.setValue(f.kommentar);
            if (f.fibu_debitor_konto_id) {
                this.debitor = {
                    fibu_konto_id: f.fibu_debitor_konto_id,
                    konto_nr: f.debitor_konto_nr,
                    bezeichnung: f.debitor_konto,
                };
            }
            if (f.fibu_kreditor_konto_id) {
                this.kreditor = {
                    fibu_konto_id: f.fibu_kreditor_konto_id,
                    konto_nr: f.kreditor_konto_nr,
                    bezeichnung: f.kreditor_konto,
                };
            }
            if (f.default_erloes_konto_id) {
                this.erloes = {
                    fibu_konto_id: f.default_erloes_konto_id,
                    konto_nr: f.erloes_konto_nr,
                    bezeichnung: f.erloes_konto,
                };
            }
        }
    }

    isValid(): boolean {
        return this.bezeichnungCtrl.valid && (!!this.debitor?.fibu_konto_id || !!(this.kontoNrCtrl.value || '').trim());
    }

    save() {
        if (!this.isValid()) {
            return;
        }
        const body: any = {
            bezeichnung: (this.bezeichnungCtrl.value || '').trim(),
            bezeichnung_kurz: (this.kurzCtrl.value || '').trim() || null,
            strasse: (this.strasseCtrl.value || '').trim() || null,
            plz: (this.plzCtrl.value || '').trim() || null,
            ort: (this.ortCtrl.value || '').trim() || null,
            aktiv: this.aktivCtrl.value ? 1 : 0,
            kommentar: (this.kommentarCtrl.value || '').trim() || null,
            fibu_debitor_konto_id: this.debitor?.fibu_konto_id || null,
            fibu_kreditor_konto_id: this.kreditor?.fibu_konto_id || null,
            default_erloes_konto_id: this.erloes?.fibu_konto_id || null,
            konto_nr: (this.kontoNrCtrl.value || '').trim() || null,
            kreditor_konto_nr: (this.kreditorKontoNrCtrl.value || '').trim() || null,
        };
        if (this.id) {
            body.sonstiger_debitor_id = this.id;
        }
        this.api.post(this.apiBaseUrl + 'sonstiger_debitor/update.php', body).subscribe({
            next: () => {
                this.messageService.infoMessage('Sonstiger Kunde gespeichert.');
                this.dialogRef.close(true);
            },
            error: err => this.messageService.errorMessage('Speichern fehlgeschlagen.', err),
        });
    }

    cancel() {
        this.dialogRef.close(false);
    }
}
